import { CircularProgress, Image, useToast, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { SectionTitle } from '../components/atoms/Title.tsx';
import { useTheme } from '../contexts/ThemeProvider.tsx';
import { Button } from '../components/atoms/Button.tsx';
import { Input } from '../components/atoms/Input.tsx';
import { FaLock } from 'react-icons/fa';
import { useMutation } from 'react-query';
import { getToken, GetTokenResponse } from '@partiu/api/auth/tokens.ts';
import '../styles.css';
import { setAccessToken } from '@partiu/api/axios.ts';
import { FaAt } from 'react-icons/fa6';

export function LoginTemplate({
  siteName,
  onLoginSuccess,
  image,
}: {
  siteName: string;
  onLoginSuccess: (data: GetTokenResponse) => void;
  image: string;
}) {
  const toast = useToast();
  const { logo } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, _] = useState(false);

  const loginMutation = useMutation(() => getToken(email, password), {
    onSuccess: function (data) {
      setAccessToken(data.token);
      onLoginSuccess(data);
    },
    onError: function (error: Record<string, any>) {
      toast({
        title: 'Oops!',
        description: error.response.data.error,
        status: 'error',
      });
    },
  });

  return (
    <VStack width={'100%'} justify="center" borderBottom="50px solid orange" backgroundColor="#fb8c00" height="100vh">
      <Image
        zIndex={0}
        objectFit="cover"
        position={'fixed'}
        left={0}
        top={0}
        height={'100vh'}
        objectPosition={'center'}
        width={'60%'}
        src={image}
      />
      <VStack height={'100%'} justify="center" width={'50%'}>
        <VStack
          className="simple-box-shadow"
          backgroundColor="#fb8c00"
          position={'fixed'}
          right={0}
          top={0}
          height={'120vh'}
          width={'60%'}
          transform={'rotate(5deg) translateX(15%) translateY(-10%)'}
          boxShadow={'0px 0px 20px rgba(0,0,0,0.3)'}
        ></VStack>
        <VStack
          className="simple-box-shadow animate__animated animate__jackInTheBox"
          spacing={5}
          align="center"
          direction="column"
          backgroundColor="#FAFAFA"
          padding="10"
          width="80%"
          zIndex={1}
          maxWidth={'300px'}
          position={'fixed'}
          borderRadius={'5px'}
        >
          <Image maxWidth="150px" objectFit="contain" src={logo} />
          <SectionTitle marginTop={'30px'} fontSize={'10pt'}>
            Sistema {siteName}
          </SectionTitle>
          <Input leftElement={<FaAt />} value={email} onValueChange={setEmail} placeholder="E-mail" />
          <Input
            leftElement={<FaLock />}
            type="password"
            value={password}
            onValueChange={setPassword}
            placeholder="Senha"
          />
          <VStack width={'100%'}>
            {loading ? (
              <CircularProgress size="40px" isIndeterminate color="green.300" />
            ) : (
              <Button isLoading={loginMutation.isLoading} onClick={() => loginMutation.mutate()} bg="#fb8c00">
                Entrar
              </Button>
            )}
          </VStack>
        </VStack>
      </VStack>
    </VStack>
  );
}
